import _pt from 'prop-types';
import 'react';
import cn from 'classnames';
import Tippy from '@tippyjs/react';
import { jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["title", "trigger", "zIndex", "delay", "placement", "hideOnClick", "styleType", "visible", "className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TooltipWrapper = function TooltipWrapper(_ref) {
  var title = _ref.title,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? "mouseenter focusin" : _ref$trigger,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 12 : _ref$zIndex,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? [200, 10] : _ref$delay,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "bottom" : _ref$placement,
      _ref$hideOnClick = _ref.hideOnClick,
      hideOnClick = _ref$hideOnClick === void 0 ? false : _ref$hideOnClick,
      _ref$styleType = _ref.styleType,
      styleType = _ref$styleType === void 0 ? "default" : _ref$styleType,
      visible = _ref.visible,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  /**
   * If any boolean is passed for 'visible', then Tippy considers the tooltip as 'controlled'
   * and does not want values for 'hideOnClick' or 'trigger'. This only persists
   * values for 'hideOnClick' and 'trigger' if the tooltip is NOT controlled.
   */
  var shouldHideOnClick;
  var triggerType;

  if (typeof visible !== "boolean") {
    shouldHideOnClick = hideOnClick;
    triggerType = trigger;
  }
  /**
   * Tippy does not allow null as a value for 'visible'. However, allowing null
   * gives consumers more flexibilty when toggling between controlled and uncontrolled states.
   * This allows null as the 'visible' prop for the Tooltip component, but removes it for Tippy.
   */


  var isVisible = visible !== null && visible !== void 0 ? visible : undefined;
  var hideOnEscapeKeyClick = {
    name: "hideOnEscapeKeyClick",
    defaultValue: true,
    fn: function fn() {
      var hideTooltipInstance = function hideTooltipInstance(_ref2) {
        var hide = _ref2.hide;
        return function (event) {
          if (event.code === "Escape" || event.keyCode === 27) {
            hide();
          }
        };
      };

      return {
        onShow: function onShow(instance) {
          document.addEventListener("keydown", hideTooltipInstance(instance));
        },
        onHide: function onHide(instance) {
          document.removeEventListener("keydown", hideTooltipInstance(instance));
        }
      };
    }
  };
  return /*#__PURE__*/jsx(Tippy, _objectSpread(_objectSpread({
    content: title,
    trigger: triggerType,
    zIndex: zIndex,
    delay: delay,
    placement: placement,
    hideOnClick: shouldHideOnClick,
    plugins: [hideOnEscapeKeyClick],
    visible: isVisible,
    className: cn("eb-tooltip", "eb-tooltip--".concat(styleType), className),
    interactive: true
  }, rest), {}, {
    children: children
  }));
};

TooltipWrapper.propTypes = {
  title: _pt.node.isRequired,
  styleType: _pt.oneOf(["default", "highlighted"]),
  className: _pt.string,
  children: _pt.element.isRequired,
  visible: _pt.oneOfType([_pt.bool, _pt.oneOf([null])])
};

export { TooltipWrapper as default };
//# sourceMappingURL=tooltip-esm.js.map
